import { render, staticRenderFns } from "./SnippetHeroHeadlines.vue?vue&type=template&id=76564200"
import script from "./SnippetHeroHeadlines.vue?vue&type=script&lang=js"
export * from "./SnippetHeroHeadlines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BasicLink: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/basic/BasicLink.vue').default})
